import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  required,
} from "react-admin";
import type { CreateProps } from "react-admin";
import { redirectToProjectModuleDashboard } from "@/containers/projects/redirect-to-project-module-dashboard";

const STATUS = [
  { id: "DRAFT", name: "Draft" },
  { id: "ACTIVE", name: "Active" },
  { id: "COMPLETED", name: "Completed" },
  { id: "ARCHIVED", name: "Archived" },
];

export const ProjectCreate = (props: CreateProps) => (
  <Create
    {...props}
    redirect={redirectToProjectModuleDashboard({
      routeProjectId: null,
      queryProjectId: null,
      projectIdField: "id",
      fallback: "list",
    })}
  >
    <SimpleForm>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="code" helperText="Optional unique code" fullWidth />
      <TextInput source="description" multiline fullWidth />
      <SelectInput source="status" choices={STATUS} defaultValue="DRAFT" />
      <NumberInput source="estimatedBudget" min={0} defaultValue={0} />
      <NumberInput
        source="unitAmount"
        min={0}
        defaultValue={0}
        helperText="Per-unit amount for takhmeen pledges"
      />
      <TextInput source="currency" defaultValue="INR" />
      <DateInput source="estimatedCompletionDate" />
    </SimpleForm>
  </Create>
);
